module.exports = __webpack_public_path__ + "img/scenic.6216f160.png";